import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'spinner']

  connect() {
    this._overlay = null
  }

  async submit(event) {
    event.preventDefault()
    const url = this.element.action + (this.element.action.includes('?') ? '&' : '?') + new URLSearchParams(new FormData(this.element)).toString()

    this.showSpinner()

    // timeout control to avoid infinite spinner when server doesn't respond
    const controller = new AbortController()
    const timeoutMs = 60_000 // 60 seconds
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs)

    try {
      const resp = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/csv' }, signal: controller.signal })
      clearTimeout(timeoutId)

      const contentType = resp.headers.get('content-type') || ''
      if (!resp.ok || !contentType.includes('text/csv')) {
        let msg = 'Error al generar el archivo.'
        try {
          const json = await resp.json()
          msg = json.message || msg
        } catch (e) {
          try {
            const text = await resp.text()
            if (text) msg = text.substr(0, 500)
          } catch (e) {}
        }
        alert(msg)
        return
      }

      const blob = await resp.blob()
      const disposition = resp.headers.get('content-disposition')
      let filename = 'consumos.csv'
      if (disposition) {
        const filenameStarMatch = disposition.match(/filename\*=(?:UTF-8'')?([^;\n]+)/i)
        if (filenameStarMatch && filenameStarMatch[1]) {
          try {
            filename = decodeURIComponent(filenameStarMatch[1].trim())
          } catch (e) {
            filename = filenameStarMatch[1].trim()
          }
        } else {
          const filenameMatch = disposition.match(/filename=(?:\")?([^;\n\"]+)(?:\")?/i)
          if (filenameMatch && filenameMatch[1]) filename = filenameMatch[1].trim()
        }
      }

      const urlBlob = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = urlBlob
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(urlBlob)
    } catch (e) {
      clearTimeout(timeoutId)
      console.error(e)
      if (e.name === 'AbortError') {
        alert('La descarga tardó demasiado y fue abortada. Por favor intente nuevamente o contacte al administrador.')
      } else {
        alert('Error al descargar el archivo. Por favor inténtelo nuevamente.')
      }
    } finally {
      this.hideSpinner()
    }
  }

  showSpinner() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = true

    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove('d-none')

    this._overlay = document.createElement('div')
    this._overlay.style.position = 'fixed'
    this._overlay.style.top = 0
    this._overlay.style.left = 0
    this._overlay.style.width = '100%'
    this._overlay.style.height = '100%'
    this._overlay.style.backgroundColor = 'rgba(0,0,0,0.35)'
    this._overlay.style.zIndex = 1050

    const inner = document.createElement('div')
    inner.style.position = 'absolute'
    inner.style.top = '50%'
    inner.style.left = '50%'
    inner.style.transform = 'translate(-50%, -50%)'
    inner.innerHTML = `<div class="spinner-border text-light" role="status"><span class="sr-only">Cargando...</span></div>`
    this._overlay.appendChild(inner)

    document.body.appendChild(this._overlay)
  }

  hideSpinner() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = false
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add('d-none')
    if (this._overlay) {
      this._overlay.remove()
      this._overlay = null
    }
  }
}
